import React, { useState } from "react";
import {
  Grid,
  Box,
  ListItemIcon,
  ListItemText,
  Collapse,
  Chip
} from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import { ListItem, ListItemButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChildYoungPersonDetails from "./personal_info_tab/child_young_person_details";
import FamilySocialInformation from "./personal_info_tab/family_social_information";
import ChildCommunication from "./personal_info_tab/child_communication";
import { paddingbox, pcolor } from "../../style2";

function Personal_Info(props) {

  const [openChildYoungPersonDetails, setOpenChildYoungPersonDetails] = useState(false);
  const [openFamilySocialInformation, setOpenFamilySocialInformation] = useState(false);
  const [openChildCommunication, setOpenChildCommunication] = useState(false);

  const isChildCommunicationEmpty = () => {
    let profile = props.profile;

    if (profile.childEducation === null)
      return true;

    if (profile.childEducation?.childPersonalityInfo && profile.childEducation?.childPersonalityInfo !== "")
      return false;
    if (profile.childEducation?.describeYourChild && profile.childEducation?.describeYourChild !== "")
      return false;
    if (profile.childEducation?.childCommunicateInfo && profile.childEducation?.childCommunicateInfo !== "")
      return false;
    if (profile.childEducation?.childInfoComparedToOtherChildren && profile.childEducation?.childInfoComparedToOtherChildren !== "")
      return false;
    if (profile.childEducation?.favoriteThingOfYourChild && profile.childEducation?.favoriteThingOfYourChild !== "")
      return false;
    if (profile.childEducation?.childPreferredPlay && profile.childEducation?.childPreferredPlay !== "")
      return false;

    return true;
  }

  const isFamilySocialInformationEmpty = () => {
    let profile = props.profile;
    if (profile.familyInformation === null)
      return true;

    if (profile.familyInformation?.siblingsWithAge && profile.familyInformation?.siblingsWithAge !== "")
      return false;
    if (profile.familyInformation?.guardians && profile.familyInformation?.guardians !== "")
      return false;

    if (profile.familyInformation?.smokingHabits && profile.familyInformation?.smokingHabits !== "")
      return false;
    if (profile.familyInformation?.pets && profile.familyInformation?.pets !== "")
      return false;

    if (profile.familyInformation?.impactOfIllnessOnFamily && profile.familyInformation?.impactOfIllnessOnFamily !== "")
      return false;
    if (profile.familyInformation?.haveHealthVisitor)
      return false;
    if (profile.familyInformation?.healthVisitorInformation && profile.familyInformation?.healthVisitorInformation !== "")
      return false;

    return true;
  }

  return (
        <Grid container>
          <Grid item sm={12}>
            <Box m={2}>
              <ListItem>
                <ListItemButton
                  onClick={() => setOpenChildYoungPersonDetails(!openChildYoungPersonDetails)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary='Child/Young Person Details' />
                  {openChildYoungPersonDetails ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openChildYoungPersonDetails} timeout='auto' unmountOnExit>
              <Box sx={{ padding: "0px 15px" }}>
                <ChildYoungPersonDetails profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isFamilySocialInformationEmpty()}
                  onClick={() => setOpenFamilySocialInformation(!openFamilySocialInformation)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }} >
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<>Family/Social Information {isFamilySocialInformationEmpty() ? <Chip label="No data provided" size="small" /> : null}</>} />
                  {openFamilySocialInformation ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openFamilySocialInformation} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <FamilySocialInformation profile={props.profile} />
              </Box>
            </Collapse>
            <Box m={2}>
              <ListItem>
                <ListItemButton disabled={isChildCommunicationEmpty()}
                  onClick={() => setOpenChildCommunication(!openChildCommunication)}
                  sx={{ color: pcolor, borderBottom: "0.1px solid grey" }}>
                  <ListItemIcon>
                    <BadgeIcon sx={{ color: pcolor }} />
                  </ListItemIcon>
                  <ListItemText primary={<div>Child’s Communication/Personality/Play  {isChildCommunicationEmpty() ? <Chip label="No data provided" size="small" /> : null}</div>} />
                  {openChildCommunication ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            </Box>
            <Collapse in={openChildCommunication} timeout='auto' unmountOnExit>
              <Box style={{ padding: "0px 15px" }}>
                <ChildCommunication profile={props.profile} />
              </Box>
            </Collapse>
          </Grid>
          <Box m={2} />
        </Grid>
  );
}

export default Personal_Info;
